import { render, staticRenderFns } from "./verticalNavMenu.vue?vue&type=template&id=098c6a36&"
import script from "./verticalNavMenu.vue?vue&type=script&lang=js&"
export * from "./verticalNavMenu.vue?vue&type=script&lang=js&"
import style0 from "./verticalNavMenu.vue?vue&type=style&index=0&id=098c6a36&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports